import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import { HttpGet } from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;
console.log("sub key xxx", SUBSCRIPTION_KEY)

const getDistinctCountry = () => {
    let parameters = null;
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DISTINCT_COUNTRY, parameters, subscriptionKey);
    return result;
}

const getDistinctRegion = (country) => {
    let query_params = {country: country};
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DISTINCT_REGION, query_params, subscriptionKey);
    return result;
}

const getDistinctProvince = (country, region) => {
    let query_params = {country, region};
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DISTINCT_PROVINCE, query_params, subscriptionKey);
    return result;
}

const getDistinctProducts = (country, region) => {
    let query_params = {};
    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_DISTINCT_PRODUCTS, query_params, subscriptionKey);
    return result;
}

const CommonOvcodeUnilabService = {
    getDistinctCountry,
    getDistinctRegion,
    getDistinctProvince,
    getDistinctProducts
}

export default CommonOvcodeUnilabService;